import servise from '@/router/axios'

export const addDataAuto = (data) => {
  return servise({
    url: '/webAutoClear/add',
    method: 'POST',
    data
  })
}

export const upDataAutov = (data) => {
  return servise({
    url: '/webAutoClear/update',
    method: 'PUT',
    data
  })
}
